export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13039.2d7237d0.jpg";